import React from 'react';
import { Button, Dropdown } from '@insurancemenu/imenu-components-lib';
import { ChevronDown } from '@insurancemenu/imenu-components-lib/dist/icons';
import { DropdownOptionType, OptionsAlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { clsx } from 'clsx';
import { EXTERNAL_IM_LINKS } from 'global/utils/generalLinks';
import { createStyles } from './styles';

const Header = (): JSX.Element => {
  const classes = createStyles();

  const dropdownOptions: DropdownOptionType[] = [
    {
      value: 'helpCenter',
      label: <Button type="text">Help Center</Button>,
      onOptionClick: (): void => {
        window.open(EXTERNAL_IM_LINKS.HELP_CENTER, '_blank');
      },
      className: classes.dropdownOption,
    },
    {
      value: 'ticket',
      label: <Button type="text">Submit Ticket / Feedback</Button>,
      onOptionClick: (): void => {
        window.open(EXTERNAL_IM_LINKS.SUBMIT_NEW_TICKET, '_blank');
      },
      className: classes.dropdownOption,
    },
  ];

  const HelpButton = (
    <Button
      className={clsx(classes.dropdownOpenedBtn, classes.dropdownButton)}
      color="primary"
      rightIconProp={<ChevronDown />}
      width="10rem"
    >
      HELP
    </Button>
  );

  return (
    <header className={classes.header}>
      <img
        alt="InsuranceMenu logo"
        src="https://static.insurancemenu.com/im/logo/insurance-menu-large.png"
        className={classes.logo}
      />

      <Dropdown
        options={dropdownOptions}
        name="HELP"
        optionsAlignment={OptionsAlignmentTypes.BOTTOM_LEFT}
        optionsWidth="22rem"
        closedElement={HelpButton}
        openedElement={HelpButton}
      />
    </header>
  );
};

export default Header;
